import styled from 'styled-components';

interface SegmentProps {
    $gapWidth: number;
    $segmentsCount: number;
}

export const Container = styled.div`
    height: 24px;
    width: 100%;
    display: flex;
    gap: 3px;
    align-items: center;
`;

export const Segment = styled.div<SegmentProps>`
    position: relative;
    width: calc(
        (100% - ${(props) => (props.$segmentsCount - 1) * props.$gapWidth}px) / ${(props) => props.$segmentsCount}
    );
    height: 5px;
    border-radius: 1px;
    background-color: ${(props) => props.theme.root.colors.basicColors['30%']};

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: inherit;
        background-color: ${(props) => props.theme.root.colors.primary.default};
        /*
        * clamp прижимает разницу (--volume - --threshold) * 1000 к диапазону 0–1.
        * Любое положительное → 1, любое неположительное → 0.
        */
        opacity: clamp(0, (var(--volume, 0) - var(--threshold)) * 1000, 1);
        transition: opacity 80ms ease;
    }
`;
